import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { ReplaySubject, Subject } from 'rxjs'
import { StreamTileThumbnail } from 'src/app/live/models/stream-tile-thumbnail.model'
@Component({
  selector: 'flo-stream-tile-thumbnail',
  templateUrl: './stream-tile-thumbnail.component.html',
  styleUrls: ['./stream-tile-thumbnail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StreamTileThumbnailComponent {
  public readonly props$ = new ReplaySubject<StreamTileThumbnail>(1)
  @Input()
  set props(props: StreamTileThumbnail) {
    if (!!props) {
      this.props$.next(props)
    }
  }

  @Input()
  showNameBadge = false

  private readonly thumbnailErrorSource = new Subject<Event>()
  public readonly thumbnailError$ = this.thumbnailErrorSource.asObservable()
  public readonly updateThumbnailError = (error: Event) => this.thumbnailErrorSource.next(error)
}
